import {Layout} from "./Layout.js";
import {SignUpViewChanger} from "../../util/view-changer/index.js";


export class InviteLayout extends  Layout {

    template() {
        const {sectionId = '', } = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop morningmate-type">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            ${this.getSubTextTemplate()}
                            <div class="corp-process-wrap">
                                <ul>
                                    <li id="corpButtonLayer"> </li>
                                    <li  id="inviterUl" class="exist-corp-wrap" style="display: none">
                                        <p>${i18next.t(login.existingTeamDesc)}</p>
                                    </li>
                                </ul>
                            </div>
                     
                        </div>
                    </article>
                </section>`
    }
    getCorpButtonLayer() {
        return $("#corpButtonLayer");
    }
    showInviteUlLayer() {
        const $inviteUlLayer = this.getInviteUlLayer();
        if($inviteUlLayer.is(":visible")) {
            return;
        }
        $inviteUlLayer.show();
    }
    getInviteUlLayer() {
        return $("#inviterUl");
    }
}